// extracted by css-extract-rspack-plugin
export default {"Label":"IssueTemplateBanner-module__Label__KSG6l","Banner":"IssueTemplateBanner-module__Banner__aGV8E"};